import { AfterContentChecked, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CollapseComponent } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreferenciasWebService } from '../../services/preferencias-web.service';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss']
})
export class CardHeaderComponent implements OnInit, OnDestroy, AfterContentChecked {

  constructor(
    private utils: Utils,
    private preferenciasWebService: PreferenciasWebService
  ) { }

  cor = localStorage.getItem('cor');

  @Input() titulo: string = '';
  @Input() collapse: CollapseComponent;
  @Input() id: string;
  private unsubscribe$ = new Subject();

  private onCollapseChangeIsSet: boolean = false;

  ngOnInit() {
  }

  ngAfterContentChecked(): void {
    if (this.collapse && !this.onCollapseChangeIsSet) {
      this.id = this.utils.formatarString(this.id || this.titulo) + '_preferences';

      const preferencias = this.preferenciasWebService.getPreference(this.id);

      if (preferencias && preferencias.cardCollapseState === 'collapsed')
        this.collapse.hide();
      else
        this.collapse.show();

      this.onCollapseChange();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private onCollapseChange() {
    this.onCollapseChangeIsSet = true;

    this.collapse.collapsed
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.salvarEstado('collapsed'));

    this.collapse.expanded
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.salvarEstado('expanded'));
  }

  private salvarEstado(estado: 'expanded' | 'collapsed') {
    this.preferenciasWebService.setPreference(this.id, { cardCollapseState: estado });
  }
}
